<template>
    <div class="main-container">
        <div class="filter-container" ref="filterContainer">
            <el-select-v2
                class="filter-item"
                filterable
                v-model="filters.shop_user_id"
                clearable
                :options="shopUserList"
                :props="shopProps"
                placeholder="请选择商户"
            />
            <SelectBrand :ifBody="0" @brandChange="onBrandChange"/>
            <!-- <el-select class="filter-item" filterable v-model="filters.brand_id" placeholder="品牌" clearable>
                <el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select> -->
            <el-select v-if="groupArray.includes('3')||groupArray.includes('21') || groupArray.includes('77')" class="filter-item" clearable filterable v-model="filters.examine_status" placeholder="审核状态">
                <el-option label="全部" value=""></el-option>
                <el-option :label="ExamineStatus[0]" :value="0"></el-option>
                <el-option :label="ExamineStatus[1]" :value="1"></el-option>
                <el-option :label="ExamineStatus[2]" :value="2"></el-option>
            </el-select>
            <el-select class="filter-item" filterable v-model="filters.appeal_status" placeholder="申诉状态">
                <el-option label="全部" value=""></el-option>
                <el-option :label="AppealStatus[0]" :value="0"></el-option>
                <el-option :label="AppealStatus[1]" :value="1"></el-option>
                <el-option :label="AppealStatus[2]" :value="2"></el-option>
            </el-select>
            <el-input class="filter-item" v-model="filters.search_value" placeholder="订单号/收货人/手机号" style="width:200px"></el-input>
            <el-date-picker class="filter-item" v-model="filters.start_date" value-format="YYYY-MM-DD" placeholder="申诉开始日期"></el-date-picker>
            <span class="filter-divider">-</span>
            <el-date-picker class="filter-item" v-model="filters.end_date" value-format="YYYY-MM-DD" placeholder="申诉结束日期"></el-date-picker>
            <el-input class="filter-item" v-model="filters.product_name" placeholder="商品名称" style="width:200px"></el-input>
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
            <!-- <el-button class="filter-btn" type="primary" @click="onBatchCheck()">批量通过</el-button> -->
            <el-button class="filter-btn" type="primary" @click="output()">批量导出</el-button>
        </div>
        <el-table :data="tableData" stripe border @selection-change="onSelectionChange">
            <el-table-column type="selection" :selectable="checkSelectable"></el-table-column>
            <!-- <el-table-column type="index" :index="tableIndex"></el-table-column> -->
            <el-table-column prop="appeal_date" label="申诉时间"></el-table-column>
            <el-table-column prop="order_id" label="订单id" width="150">
                 <template #default="scope">
                    订单id：{{scope.row.order_id}}<br/>
                    订单号：{{scope.row.order_no}}<br/>
                </template>
            </el-table-column>
            <el-table-column label="商品">
                <template #default="scope">
                    <img :src="scope.row.image_path" width="50" height="40" class="image_path"/>
                </template>
            </el-table-column>
            <el-table-column label="商品信息" width="170">
                <template #default="scope">
                    品牌：{{scope.row.brand_name}}<br/>商品：{{scope.row.product_name}}<br/>规格：{{scope.row.spec_name}}<br/>
                </template>
            </el-table-column>
            <el-table-column prop="quantity" label="数量"></el-table-column>
            <el-table-column prop="ship_amount" label="运费"></el-table-column>
            <el-table-column prop="total_amount" label="订单金额"></el-table-column>
            <el-table-column label="发货信息" width="170">
                <template #default="scope">
                    收货人：{{scope.row.name}}<br/>手机号：{{scope.row.phone}}<br/>
                    <span v-if="scope.row.ship_time != '' && scope.row.ship_time != null">发货时间:{{scope.row.ship_time}}</span><br/>
                    <span v-if="scope.row.refund_time != '' && scope.row.refund_time != null">退款时间:{{scope.row.refund_time}}</span>
                </template>
            </el-table-column>
            <el-table-column label="延迟发货" width="124">
                <template #default="scope">
                    <template v-if="scope.row.delay_delivery">
                        <span>类型：{{DelayTypes[scope.row.delay_delivery_type]}}</span><br/>
                        <span>时间：{{scope.row.delay_delivery_time}}</span><br/>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="人工罚款" width="200">
                <template #default="scope">
                    <template v-if="scope.row.manual_fine.fine_date">
                        <span>罚款时间：{{scope.row.manual_fine.fine_date}}</span><br/>
                        <span>罚款原因：{{scope.row.manual_fine.fine_reason}}</span><br/>
                        <span>罚款金额：{{scope.row.manual_fine.fine_money}}</span><br/>
                        <span>减免金额：{{scope.row.manual_fine.fine_reduce}}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="系统罚款" width="200">
                <template #default="scope">
                    <template v-if="scope.row.system_fine.fine_date">
                        <span>罚款时间：{{scope.row.system_fine.fine_date}}</span><br/>
                        <span>罚款原因：{{scope.row.system_fine.fine_reason}}</span><br/>
                        <span>罚款金额：{{scope.row.system_fine.fine_money}}</span><br/>
                        <span>减免金额：{{scope.row.system_fine.fine_reduce}}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="express_status_val" label="商品状态"></el-table-column>
            <el-table-column v-if="groupArray.includes(role)" prop="examine_status_val" label="审核状态"></el-table-column>
            <el-table-column prop="appeal_status_val" label="申诉状态"></el-table-column>
            <el-table-column label="申诉原因" width="300">
                <template #default="scope">
                    <p>{{ scope.row.appeal_reason }}</p>
                    <ul v-if="scope.row.appeal_file" class="preview-list el-upload-list" style="height:60px;overflow:hidden;">
                        <li class="preview-item el-upload-list__item" v-for="(item, index) in scope.row.appeal_file.split(',')" :key="item">
                            <el-image
                                :src="item"
                                :preview-src-list="scope.row.appeal_file.split(',')"
                                :initial-index="index"
                                fit="scale-down"
                                hide-on-click-modal
                                preview-teleported
                                :z-index="3000"
                                style="width:60px"
                            ></el-image>
                        </li>
                    </ul>
                </template>
            </el-table-column>
            <el-table-column prop="reject_reason" label="驳回原因"></el-table-column>
            <el-table-column label="操作" fixed="right" width="100">
                <!-- 0-待审核，1-审核通过，2-驳回 -->
                <template #default="scope">
                    <div class="action-list">
                        <el-button type="primary" size="small" @click="onCheck(scope.row.id)">审核 </el-button>
                        <!-- <el-button :disabled="scope.row.appeal_status != 0" type="primary" size="small" @click="onCheck(scope.row.id, 1)">审核通过</el-button>
                        <el-button class="mt10" :disabled="scope.row.appeal_status != 0" type="warning" size="small" @click="currOrderItemId=scope.row.id;dialogVisible=true">驳回</el-button> -->
                        <el-button class="mt10" type="primary" size="small" @click="router.push('/merchant-admin/order-edit?order_id='+scope.row.order_id)">订单详情</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.page" :total="total" @pageChange="onPageChange" @sizeChange="onSizeChange" />
        <!-- <el-pagination
            @current-change="handleCurrentChange"
            v-model:currentPage="filters.page"
            :page-size="filters.limit"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination> -->
        <!-- 驳回弹框 -->
        <!-- <el-dialog title="驳回" v-model="dialogVisible" :before-close="dialogBeforeClose">
            <el-form label-width="120px">
                <el-form-item label="驳回原因" required style="width:450px">
                    <el-input type="textarea" :rows="5" maxlength="150" show-word-limit v-model="reject_reason"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="dialogBeforeClose">取 消</el-button>
                <el-button type="primary" @click="onCheck(currOrderItemId, 2)">确 定</el-button>
            </template>
        </el-dialog> -->
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive, nextTick,onActivated } from 'vue'
import { useStore } from '@/store/index'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'
import { DelayTypes, AppealStatus,ExamineStatus } from '@/enums/order'
import SelectBrand from '@/components/SelectBrand.vue'
export default defineComponent({
name: 'MerchantList',
components: {SelectBrand,Pagination},
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()
    const groupString = store.state.user.userInfo.group_id
    const groupArray = groupString.split(',')
    const role = "3"
    const state = reactive({
        filters: {
            search_value:   '', // 订单号/收货人/手机号
            brand_id:       '', // 搜索品牌ID
            start_date:     '', // 开始日期
            end_date:       '', // 结束日期
            product_name:      '', // 商品名称
            shop_user_id:   undefined, // 商户列表
            appeal_status:0,//申诉状态
            examine_status: 0,//审核状态待审核
            limit:          10, // 每页条数
            page:           1,  // 当前页码
        },
        shopProps: {
            value: 'id',
            label: 'shop_description'
        },
        tableData:      [], // 表格数据
        // tableHeight:    0,  // table 高度
        shopUserList:   [], // 用户列表数据
        total:          0,  // 总条数
        brandList:      [], // 当前用户关联品牌（非商户类获取全部）

        //dialogVisible:  false,  // 申诉弹框
        appeal_reason:  '',     // 申诉原因
        appeal_file:    [],     // 申诉证明
        reject_reason:  '',     // 驳回原因
        currOrderItemId:'',     // 当前操作订单ID
        currAppeal:     '',     // 当前操作申诉类型：1-可进行申诉；2-已申诉，可获取申诉信息
        orderItemIds:   '',     // 批量申诉选中ID
        seat:           '',     // 批量申诉索引，用于反显提示第几条异常
        
        // 当前页面变更
        handleCurrentChange(val) {
            state.filters.page = val
            state.getList();
        },
        // 获取表格数据
        getList(){
            //如果是商务则删除默然属性运营待审核
            if(groupArray.includes('18')){
                // if(state.filters.appeal_status){
                //     state.filters.appeal_status = 0
                // }
                delete state.filters.examine_status
            }
            proxy.$http.get(`/admin/fine_order/getFineAppealList?${joinParams({...state.filters})}`).then(res => {
                if(res.code == 0){
                    state.tableData = res.data
                    state.total = res.count || 0
                }else{
                    state.tableData = [];
                }
            })
            state.getBrandList()
        },
        // 获取当前用户关联品牌列表
        getBrandList:()=>{
            proxy.$http.post('/admin/shop_product/getBrandList?id_show=1').then((res) => {
                state.brandList = res.data
            })
        },
        onBrandChange (val) {
            state.filters.brand_id = val
        },
        // 获取用户列表数据
        getShopList:()=>{
            proxy.$http.get('/admin/shop_product/getShopList').then(res => {
                if(res.code == 200){
                    state.shopUserList = res.data;
                }else{
                    state.shopUserList = [];
                }
            })
        },
        // 搜索
        search(){
            state.filters.page = 1;
            state.getList();
        },
        onPageChange (val) {
            state.filters.page = val
            state.getList()
        },
        onSizeChange  (val) {
            state.filters.limit = val
            state.getList()
        },
        // 导出
        output(){
            window.open(`${Keys.baseUrl}/admin/fine_order/exportFineAppealData?${joinParams({...state.filters,user_id:store.state.user.userInfo.id})}`)
        },
        // 表格 index 连续
        tableIndex: (index) => {
            const { page, limit } = state.filters
            return (page - 1) * limit + index + 1
        }
    })
    // 跳转到审核编辑页面
    const onCheck = (id) => {
        router.push(`/check/appeal-edit?order_item_id=${id}`)
    }
    // 批量审核通过
    // const onBatchCheck = () => {
    //     const { orderItemIds:order_item_id, seat } = state
    //     if (!order_item_id) {
    //         return proxy.$message({ type: 'error', message: '请至少勾选一条记录' })
    //     }
    //     proxy.$confirm('确定批量审核通过已勾选商品吗？', '提示', {
    //         type: 'warning'
    //     }).then(() => {
    //         proxy.$http.post('/admin/fine_order/checkFineAppealBatch', {order_item_id, seat, status:1, reject_reason:''}).then(res => {
    //             const {code, data, msg} = res
    //             if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    //             proxy.$message({ type: 'success', message: '保存成功' })
    //             state.getList()
    //         })
    //     }).catch(() => {
    //         console.log('取消批量审核通过')
    //     })
    // }
    // 申诉弹框关闭前清空数据
    // const dialogBeforeClose = () => {
    //     state.dialogVisible = false
    //     state.appeal_reason = ''
    //     state.appeal_file = ''
    //     state.reject_reason = ''
    // }
    // 设置不可选择行
    const checkSelectable = (row) => {
        return row.appeal_status==0
    }
    // 选中监听
    const onSelectionChange = (rows) => {
        const { tableData, filters } = state
        const { limit, page } = filters
        let idArr = []
        let idxArr = []
        rows.map(item => {
            const id = item.id
            idArr.push(id)
            idxArr.push((tableData.findIndex(sItem => sItem.id === id)) + limit * (page - 1) + 1)
        })
        state.orderItemIds = idArr.join(',')
        state.seat = idxArr.join(',')
    }
    // 设置 table 高度
    // const setTableHeight = () => {
    //     nextTick(() => {
    //         let headerHeight = 50,  // 头部高度
    //             filterHeight = proxy.$refs.filterContainer.offsetHeight + 30, // 搜索条件框高度 + 间距
    //             paginationHeight = 62 // 分页栏高度 + 与 table 之间的间距
    //         state.tableHeight = window.innerHeight - headerHeight - filterHeight - paginationHeight
    //     })
    // }
    // 设置 table 高度
    // setTableHeight()
    // 监听窗口变化，重置 table 高度
    // window.onresize = setTableHeight
    // 注销 onresize 监听
    onBeforeRouteLeave(() => { window.onresize = null })
    onActivated(() => {
        state.getList()
    })
     
    state.getList()
    state.getShopList()
    return { ...toRefs(state), role,groupString,groupArray, router, Keys, store, onCheck, onSelectionChange, checkSelectable, DelayTypes, AppealStatus,ExamineStatus }
}
})
</script>